import PropTypes from 'prop-types';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';
import ModalBodyKarmaEarnPlayMobileDevices from 'components/molecules/ModalBodyKarmaEarnPlayMobileDevices/ModalBodyKarmaEarnPlayMobileDevices';

const ModalKarmaEarnPlayMobileDevices = props => {
  const { closeModal, sourcePage, item } = props;

  return (
    <Alooma.GameIdContext.Provider value={item.id}>
      <Modal
        source={sourcePage}
        onClose={closeModal}
        aloomaModalName={ALOOMA.MODAL_NAMES.KARMA_EARN_PLAY_MOBILE_DEVICES}
        aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
        sendPageView={false}
      >
        <ModalBodyKarmaEarnPlayMobileDevices {...props} />
      </Modal>
    </Alooma.GameIdContext.Provider>
  );
};

ModalKarmaEarnPlayMobileDevices.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
};

export default ModalKarmaEarnPlayMobileDevices;
